import { apiFetch } from '@/lib/api'
import type { ConversationRouteDecision } from '@/types/conversationRuntime'

const API_BASE = import.meta.env.VITE_API_URL || 'https://sineapi-production-8db6.up.railway.app'

export interface RouteConversationMessageInput {
  message: string
  conversationId?: string | null
  conversationHistory?: Array<{ role: 'user' | 'assistant' | 'agent' | 'system'; content: string }>
  overrideMode?: ConversationRouteDecision['mode']
  studioMode?: boolean
  enabledConnectors?: string[]
}

export interface RouteConversationMessageResult {
  decision: ConversationRouteDecision
}

export async function routeConversationMessage(
  input: RouteConversationMessageInput,
): Promise<RouteConversationMessageResult> {
  const controller = new AbortController()
  const timeout = window.setTimeout(() => controller.abort(), 1500)
  let response: Response
  try {
    response = await apiFetch(`${API_BASE}/api/conversation/route`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
      body: JSON.stringify({
        message: input.message,
        conversation_id: input.conversationId ?? undefined,
        conversation_history: input.conversationHistory ?? [],
        override_mode: input.overrideMode ?? undefined,
        studio_mode: input.studioMode ?? false,
        enabled_connectors: input.enabledConnectors ?? [],
      }),
    })
  } finally {
    window.clearTimeout(timeout)
  }

  if (!response.ok) {
    const text = await response.text()
    throw new Error(`Runtime route failed: ${response.status} ${text}`)
  }

  return response.json() as Promise<RouteConversationMessageResult>
}
